import { connect } from 'react-redux'
import compose from 'recompose/compose'
import withProps from 'recompose/withProps'
import OverflowContextMenu from '../components/OverflowContextMenu'
import { setIsWindowFullScreen } from 'aria-viewer/tour/tourActions'
import { requestFullScreen, exitFullScreen } from 'aria-viewer/utils/fullScreen'
import { showVRInstructionDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import { showDescription } from 'aria-viewer/tour/tourActions'
import { Capabilities, displayFeatureBasedOnViewportSize } from 'aria-viewer/utils/capabilities'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'

const props = withProps(
    ({
        isVRButtonEnabled,
        isWindowFullScreen,
        handleFullScreenButtonClick,
        onVrClick,
        useResponsiveUI,
        onInfoButtonClicked,
        viewportHeight,
        viewportWidth,
    }) => {
        const list = []
        if (isVRButtonEnabled) {
            list.push({
                title: 'View in VR',
                action: onVrClick,
                icon: {
                    name: 'vr',
                },
            })
        }
        if (!useResponsiveUI) {
            list.push({
                title: 'Fullscreen',
                action: handleFullScreenButtonClick,
                icon: {
                    name: isWindowFullScreen ? 'minimize' : 'expand',
                },
            })
        }
        if (
            displayFeatureBasedOnViewportSize(Capabilities.OVERFLOW_MENU_TOUR_BUTTON, {
                viewportHeight,
                viewportWidth,
            }) &&
            useResponsiveUI
        ) {
            list.push({
                title: 'Info',
                action: onInfoButtonClicked,
                icon: {
                    name: 'info_desktop',
                },
            })
        }
        if (useResponsiveUI) {
            list.push({
                title: 'Language',
            })
            list.push({
                title: 'Share',
            })
        }
        return {
            options: {
                list,
            },
        }
    }
)

const mapStateToProps = state => ({
    isMobile: state.getIn(['device', 'isDeviceMobile']),
    isWindowFullScreen: state.getIn(['tour', 'isWindowFullScreen']),
    isVRButtonEnabled: state.getIn(['config', 'isVRButtonEnabled']),
    useResponsiveUI: state.getIn(['device', 'useResponsiveUI']),
    viewportWidth: state.getIn(['device', 'viewportWidth']),
    viewportHeight: state.getIn(['device', 'viewportHeight']),
})

const mapDispatchToProps = dispatch => ({
    onFullScreenButtonClick: isWindowFullScreen => {
        if (isWindowFullScreen) {
            exitFullScreen()
            dispatch(setIsWindowFullScreen(false))
        } else {
            requestFullScreen()
            dispatch(setIsWindowFullScreen(true))
        }
    },

    onInfoButtonClicked: () => {
        dispatch(showDescription())
    },

    onVrClick: item => {
        dispatch(showVRInstructionDrawer())
    },
})

const mergeProps = (state, actions, ownProps) => ({
    ...state,
    ...actions,
    ...ownProps,

    handleFullScreenButtonClick: item => {
        const { isWindowFullScreen } = state

        actions.onFullScreenButtonClick(isWindowFullScreen)
    },
})

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    ),
    props
)(OverflowContextMenu)
